<template>
  <ul>
    <li v-for="item in obj" :key="item.title">
      <div class="left">
        <img :src="$baseURL + item.thumb" alt="" />
      </div>
      <div class="right">
        <h2>{{ item.title }}</h2>
        <p>
          {{ item.description }}
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import image from "@/assets/image/solution_cj.png";

export default {
  props: {
    obj: {
      type: Array,
    },
  },
  data() {
    return { image };
  },
};
</script>

<style lang="less" scoped>
ul {
  li {
    display: flex;
    align-items: center;

    .left {
      width: 50%;

      img {
        width: 100%;
        border-radius: 10px;
      }
    }

    .right {
      flex: 1;
      margin-left: 80px;

      h2 {
        font-size: 24px;
        margin-bottom: 20px;
      }

      p {
        color: #666;
        line-height: 2;
      }
    }

    &+li {
      margin-top: 30px;
    }

    &:nth-child(2n) {
      flex-direction: row-reverse;

      .right {
        margin-left: 0;
        margin-right: 80px;
      }
    }
  }
}

@media (max-width: 850px) {
  ul {
    li {
      display: block;

      .left,
      .right {
        width: 100%;
        margin-left: 0;

        h2 {
          margin: 5px 0;
        }
      }
    }
  }
}
</style>